module.exports = __webpack_public_path__ + "media/re/black-8c0637e4.svg";